{
  "title": "Awaken",
  "source": "Player's Handbook",
  "levelAndSchool": "5th-level transmutation",
  "level": 5,
  "castingTime": "8 hours",
  "range": "Touch",
  "components": "V, S, M (an agate worth at least 1,000 gp, which the spell consumes)",
  "duration": "Instantaneous",
  "description": [
    "After spending the casting time tracing magical pathways within a precious gemstone, you touch a huge or smaller beast or plant. The target must have either no Intelligence score or an Intelligence of 3 or less.",
    "The target gains an Intelligence of 10. The target also gains the ability to speak one language you know. If the target is a plant, it gains the ability to move its limbs, roots, vines, creepers, and so forth, and it gains senses similar to a human’s. Your DM chooses statistics appropriate for the awakened plant, such as the statistics for the awakened shrub or the awakened tree.",
    "The awakened beast or plant is charmed by you for 30 days or until you and your companions do anything harmful to it. When the charmed condition ends, the awakened creature chooses whether to remain friendly to you, based on how you treated it while it was charmed."
  ],
  "spellLists": ["bard", "druid"]
}
